export const START_FETCH_IMAGES = 'START_FETCH_IMAGES';
export const STOP_FETCH_IMAGES = 'STOP_FETCH_IMAGES';
export const SET_IMAGES_ITEM = 'SET_IMAGES_ITEM';
